import type { BillingAccountStats, UserSignups } from "@warrenio/api-spec/spec.oats.gen";

export const adminBillingAccountStatsExample: BillingAccountStats = {
    total_first_billing_accounts: 11775,
    last_x_days_first_billing_accounts: [
        {
            days: 30,
            users: 39,
        },
        {
            days: 60,
            users: 1100,
        },
    ],
    first_billing_accounts_monthly: [
        {
            month: 1764547200,
            users: 39,
        },
        {
            month: 1761955200,
            users: 161,
        },
        {
            month: 1759276800,
            users: 92,
        },
        {
            month: 1756684800,
            users: 86,
        },
        {
            month: 1754006400,
            users: 110,
        },
        {
            month: 1751328000,
            users: 119,
        },
        {
            month: 1748736000,
            users: 150,
        },
        {
            month: 1746057600,
            users: 164,
        },
        {
            month: 1743465600,
            users: 127,
        },
        {
            month: 1740787200,
            users: 129,
        },
        {
            month: 1738368000,
            users: 151,
        },
        {
            month: 1735689600,
            users: 166,
        },
        {
            month: 1733011200,
            users: 262,
        },
    ],
    total_financial_commitment: 7759,
    last_x_days_financial_commitment: [
        {
            days: 30,
            users: 14,
        },
        {
            days: 60,
            users: 763,
        },
    ],
    financial_commitment_monthly: [
        {
            month: 1764547200,
            users: 14,
        },
        {
            month: 1761955200,
            users: 74,
        },
        {
            month: 1759276800,
            users: 62,
        },
        {
            month: 1756684800,
            users: 55,
        },
        {
            month: 1754006400,
            users: 80,
        },
        {
            month: 1751328000,
            users: 73,
        },
        {
            month: 1748736000,
            users: 73,
        },
        {
            month: 1746057600,
            users: 71,
        },
        {
            month: 1743465600,
            users: 56,
        },
        {
            month: 1740787200,
            users: 49,
        },
        {
            month: 1738368000,
            users: 55,
        },
        {
            month: 1735689600,
            users: 55,
        },
        {
            month: 1733011200,
            users: 73,
        },
    ],
};

export const adminUserSignupsStatsExample: UserSignups = {
    total_signups: 15007,
    last_x_days_signups: [
        {
            days: 30,
            users: 2375,
        },
        {
            days: 60,
            users: 4338,
        },
    ],
    monthly_signups: [
        {
            month: "2025-12-01 00:00:00",
            users: 9,
        },
        {
            month: "2025-11-01 00:00:00",
            users: 228,
        },
        {
            month: "2025-10-01 00:00:00",
            users: 204,
        },
        {
            month: "2025-09-01 00:00:00",
            users: 178,
        },
        {
            month: "2025-08-01 00:00:00",
            users: 224,
        },
        {
            month: "2025-07-01 00:00:00",
            users: 266,
        },
        {
            month: "2025-06-01 00:00:00",
            users: 247,
        },
        {
            month: "2025-05-01 00:00:00",
            users: 230,
        },
        {
            month: "2025-04-01 00:00:00",
            users: 170,
        },
        {
            month: "2025-03-01 00:00:00",
            users: 178,
        },
        {
            month: "2025-02-01 00:00:00",
            users: 206,
        },
        {
            month: "2025-01-01 00:00:00",
            users: 218,
        },
        {
            month: "2024-12-01 00:00:00",
            users: 339,
        },
    ],
};
